import request from '@/utils/request'

// 获取路由
export const getRouters = () => {
  return request({
    url: '/leo/menu/getRouters',
    method: 'get'
  })
}
export const getInfo = () => {
  return request({
    url: '/virgo/company/getInfo',
    method: 'post'
  })
}
// 待办事项
export const matter = () => {
  return request({
    url: '/virgo/index/matter',
    method: 'get'
  })
}
